// extracted by mini-css-extract-plugin
module.exports = {"countdown":"ki","srOnly":"li"};